import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../core/auth/auth.service';
import { environment } from 'environments/environment';
import {
    BasicResponseInterface,
    BasicResponseModel,
} from 'app/interfaces/transcodificaciones.interface';
import { LugarAtencionInterface, Prestador } from 'app/interfaces/prestadorLugarDeAtencion.interface';
import { CallsResponse, StatisticsParameters, StatisticsResponse, TicketsAndSurveysResponse } from 'app/interfaces/estadisticas.interface';

@Injectable({
    providedIn: 'root',
})
export class StatisticsService {
    private unexaURL = environment.url;

    constructor(
        private _httpClient: HttpClient,
        private _authService: AuthService,
    ) {}

    getTotalCalls({fechaDesde, fechaHasta, operadorId, tipoEstadistica}: StatisticsParameters): Promise<any> {
        let url: string = `${this.unexaURL}/estadisticas/calls/count?dateFrom=${fechaDesde}&dateTo=${fechaHasta}`;
        console.log(url);


        return new Promise<any>((resolve, reject) => {
            this._httpClient
                .get(url, this._authService.headers_http)
                .subscribe({
                    next: (response: BasicResponseInterface<CallsResponse[]>) => {
                        console.log('response', response);

                        let finalSerieArray: any[] = [];
                        let finalLabelArray: string[] = [];

                        if(response.response.length >0){
                            response.response.forEach(resultPerMonth => {
                                console.log(resultPerMonth);
                                finalLabelArray.push(resultPerMonth.month);
                                finalSerieArray.push(resultPerMonth.totalCalls);
                            });
                        }

                        let statisticsData;

                        statisticsData = {
                            labels: finalLabelArray,
                            series: [
                                {
                                    name: 'Cantidad de llamados',
                                    type: 'column',
                                    data: finalSerieArray,
                                },
                            ]
                        }
                        resolve({statisticsData, tableData: response.response, tableHeaders: ['Fecha', 'Llamadas atendidas', 'Llamadas esperadas', 'Porcentaje'], valueType: 'number'});
                    },
                    error: (errorResponse: any) => {
                        console.log('errorResponse', errorResponse);
                        let statisticsData = {
                            labels: 'Mes',
                            series: [
                                {
                                    name: 'Cantidad de llamados',
                                    type: 'column',
                                    data: [],
                                },
                            ]
                        }
                        reject({statisticsData, tableData: [], tableHeaders: ['Fecha', 'Llamadas atendidas', 'Llamadas esperadas', 'Porcentaje'], valueType: 'number'});
                    },
                });
            // resolve({statisticsData, tableData: response.response});
        });
    }

    getTotalCallsPerOperator({fechaDesde, fechaHasta, operadorId}: StatisticsParameters): Promise<any> {
        let finalSerieArray: any[] = [];
        let finalLabelArray: string[] = [];
        let tableData: {fecha: string, variable1: number, variable2: number, valorFinal: number}[] = [];

        if(operadorId){
            console.log(operadorId);


            let url: string = `${this.unexaURL}/estadisticas/calls/operator?dateFrom=${fechaDesde}&dateTo=${fechaHasta}&agentId=${operadorId}`;
            console.log(url);

            return new Promise<any>((resolve, reject) => {
                this._httpClient
                    .get(url, this._authService.headers_http)
                    .subscribe({
                        next: (response: BasicResponseInterface<CallsResponse[]>) => {
                            const reversedResponse = response.response.reverse();
                            reversedResponse.forEach(resultPerMonth => {
                                console.log(resultPerMonth);
                                finalLabelArray.push(resultPerMonth.month);
                                finalSerieArray.push(resultPerMonth.percentage);
                                tableData.push({variable1: resultPerMonth.callsOperator, variable2: resultPerMonth.cantCallsPerOperator, valorFinal: resultPerMonth.percentage, fecha: resultPerMonth.month})
                            });

                            let statisticsData;

                            statisticsData = {
                                labels: finalLabelArray,
                                series: [
                                        {
                                            name: `Cantidad de llamados para el/la operador/a`,
                                            type: 'column',
                                            data: finalSerieArray,
                                        },
                                    ]
                            }
                            console.log('response', response);
                            resolve({statisticsData, tableData, tableHeaders: ['Fecha', 'Llamadas atendidas', 'Llamadas esperadas', 'Porcentaje'],valueType: 'percentage'});
                        },
                        error: (errorResponse: any) => {
                            console.log('errorResponse', errorResponse);
                            let statisticsData = {
                                labels: finalLabelArray,
                                series: [
                                        {
                                            name: `Cantidad de llamados para el/la operador/a`,
                                            type: 'column',
                                            data: finalSerieArray,
                                        },
                                    ]
                            }
                            reject({statisticsData, tableData: [], tableHeaders: ['Fecha', 'Llamadas atendidas', 'Llamadas esperadas', 'Porcentaje'], valueType: 'percentage'});
                        },
                    });
            });
        } else {

            let url: string = `${this.unexaURL}/estadisticas/calls/count?dateFrom=${fechaDesde}&dateTo=${fechaHasta}`;
            console.log(url);

            return new Promise<any>((resolve, reject) => {
                this._httpClient
                    .get(url, this._authService.headers_http)
                    .subscribe({
                        next: (response: BasicResponseInterface<CallsResponse[]>) => {

                            response.response.forEach(resultPerMonth => {
                                console.log(resultPerMonth);
                                finalLabelArray.push(resultPerMonth.month);
                                finalSerieArray.push(resultPerMonth.percentage);
                                tableData.push({variable1: resultPerMonth.totalCalls, variable2: resultPerMonth.totalAttendedCalls, valorFinal: resultPerMonth.percentage, fecha: resultPerMonth.month})
                            });

                            let statisticsData;

                            statisticsData = {
                                labels: finalLabelArray,
                                series: [
                                        {
                                            name: `Cantidad de llamados atendidos`,
                                            type: 'column',
                                            data: finalSerieArray,
                                        },
                                    ]
                            }
                            console.log('response', response);
                            resolve({statisticsData, tableData, tableHeaders: ['Fecha', 'Llamadas totales', 'Llamadas atendidas', 'Porcentaje'], valueType: 'percentage'});
                        },
                        error: (errorResponse: any) => {
                            console.log('errorResponse', errorResponse);
                            let statisticsData = {
                                labels: finalLabelArray,
                                series: [
                                        {
                                            name: `Cantidad de llamados atendidos`,
                                            type: 'column',
                                            data: finalSerieArray,
                                        },
                                    ]
                            }
                            reject({statisticsData, tableData, tableHeaders: ['Fecha', 'Llamadas totales', 'Llamadas atendidas', 'Porcentaje'], valueType: 'percentage'});
                        },
                    });
            });
        }
    }

    getSatisfactionAndAnsweredSurveys({fechaDesde, fechaHasta, operadorId, tipoEstadistica}: StatisticsParameters): Promise<any> {
        let url: string = `${this.unexaURL}/estadisticas/tickets/satisfaccion/respuestas?dateFrom=${fechaDesde}&dateTo=${fechaHasta}`;
        console.log(url);

        return new Promise<any>((resolve, reject) => {
            this._httpClient
                .get(url, this._authService.headers_http)
                .subscribe({
                    next: (response: BasicResponseInterface<TicketsAndSurveysResponse[]>) => {
                        let finalSerieArray: any[] = [];
                        let finalLabelArray: string[] = [];
                        let tableData: {fecha: string, variable1: number, variable2: number, valorFinal: number}[] = [];

                        if(tipoEstadistica == 0){
                            response.response.forEach(resultPerMonth => {
                                console.log(resultPerMonth);
                                finalLabelArray.push(resultPerMonth.mes);
                                finalSerieArray.push(resultPerMonth.satisfaccion);
                                tableData.push({variable1: resultPerMonth.puntos, variable2: resultPerMonth.cantidadEncuestas, valorFinal: resultPerMonth.satisfaccion, fecha: resultPerMonth.mes})
                            });
                        } else {
                            response.response.forEach(resultPerMonth => {
                                console.log(resultPerMonth);
                                finalLabelArray.push(resultPerMonth.mes);
                                finalSerieArray.push(resultPerMonth.respuestas);
                                tableData.push({variable1: resultPerMonth.cantidadEncuestas, variable2: resultPerMonth.cantidadReclamos, valorFinal: resultPerMonth.respuestas, fecha: resultPerMonth.mes})
                            });
                        }
                        let statisticsData;
                        statisticsData = {
                            labels: finalLabelArray,
                            series: [
                                    {
                                        name: tipoEstadistica == 0 ? 'Porcentaje de satisfacción' : 'Encuestas respondidas',
                                        type: 'column',
                                        data: finalSerieArray,
                                    },
                                ]
                        }
                        console.log(statisticsData);
                        console.log('response', response);
                        let headers: string[]
                        if(tipoEstadistica == 0) {
                            headers = ['Fecha', 'Puntaje obtenido', 'Encuentas respondidas', 'Porcentaje']
                        } else {
                            headers = ['Fecha', 'Cantidad encuestas', 'Cantidad reclamos', 'Porcentaje']
                        }
                        resolve({statisticsData, tableData, tableHeaders: headers, valueType: 'percentage'});
                    },
                    error: (errorResponse: any) => {
                        console.log('errorResponse', errorResponse);
                        let statisticsData = {
                            labels: 'Mes',
                            series: [
                                    {
                                        name: tipoEstadistica == 0 ? 'Porcentaje de satisfacción' : 'Encuestas respondidas',
                                        type: 'column',
                                        data: '',
                                    },
                                ]
                        }
                        let headers: string[]
                        if(tipoEstadistica == 0) {
                            headers = ['Fecha', 'Puntaje obtenido', 'Encuestas respondidas', 'Porcentaje']
                        } else {
                            headers = ['Fecha', 'Cantidad encuestas', 'Cantidad reclamos', 'Porcentaje']
                        }
                        reject({statisticsData, tableData: [], tableHeaders: headers, valueType: 'percentage'});
                    },
                });
        });
    }

    getCallsBasedInUsers({fechaDesde, fechaHasta}: StatisticsParameters): Promise<any> {
        let finalSerieArray: any[] = [];
        let finalLabelArray: string[] = [];
        let tableData: {fecha: string, variable1: number, variable2: number, valorFinal: number}[] = [];

        let url: string = `${this.unexaURL}/estadisticas/calls/count/prestadores?dateFrom=${fechaDesde}&dateTo=${fechaHasta}`;
        console.log(url);

        return new Promise<any>((resolve, reject) => {
            this._httpClient
                .get(url, this._authService.headers_http)
                .subscribe({
                    next: (response: BasicResponseInterface<CallsResponse[]>) => {
                        response.response.forEach(resultPerMonth => {
                            console.log(resultPerMonth);
                            finalLabelArray.push(resultPerMonth.month);
                            finalSerieArray.push(resultPerMonth.percentage);
                            tableData.push({variable1: resultPerMonth.totalCalls, variable2: resultPerMonth.cantPrestadores, valorFinal: resultPerMonth.percentage, fecha: resultPerMonth.month})
                        });

                        let statisticsData;
                        statisticsData = {
                            labels: finalLabelArray,
                            series: [
                                {
                                    name: `Porcentaje de llamados/usuarios`,
                                    type: 'column',
                                    data: finalSerieArray,
                                },
                            ]
                        }
                        console.log('response', response);
                        resolve({statisticsData, tableData, tableHeaders: ['Fecha', 'Llamadas recibidas', 'Cantidad de prestadores', 'Porcentaje'], valueType: 'percentage'});
                    },
                    error: (errorResponse: any) => {
                        console.log('errorResponse', errorResponse);
                        let statisticsData;
                        statisticsData = {
                            labels: finalLabelArray,
                            series: [
                                {
                                    name: `Porcentaje de llamados/usuarios`,
                                    type: 'column',
                                    data: finalSerieArray,
                                },
                            ]
                        }
                        reject({statisticsData, tableData, tableHeaders: ['Fecha', 'Llamadas recibidas', 'Cantidad de prestadores', 'Porcentaje'], valueType: 'percentage'});
                    },
                });
        });
    }

    getTicketsBasedInUsers({fechaDesde, fechaHasta}: StatisticsParameters): Promise<BasicResponseInterface<CallsResponse[]>> {
        let url: string = `${this.unexaURL}/estadisticas/tickets/count/prestadores?dateFrom=${fechaDesde}&dateTo=${fechaHasta}`;
        console.log(url);

        return new Promise<any>((resolve, reject) => {
            this._httpClient
                .get(url, this._authService.headers_http)
                .subscribe({
                    next: (response: BasicResponseInterface<CallsResponse[]>) => {
                        let finalSerieArray: any[] = [];
                        let finalLabelArray: string[] = [];
                        let tableData: {fecha: string, variable1: number, variable2: number, valorFinal: number}[] = [];

                        response.response.forEach(resultPerMonth => {
                            console.log(resultPerMonth);
                            finalLabelArray.push(resultPerMonth.month);
                            finalSerieArray.push(resultPerMonth.percentage);
                            tableData.push({variable1: resultPerMonth.totalTickets, variable2: resultPerMonth.cantPrestadores, valorFinal: resultPerMonth.percentage, fecha: resultPerMonth.month})
                        });

                        let statisticsData;

                        statisticsData = {
                            labels: finalLabelArray,
                            series: [
                                {
                                    name: `Porcentaje de tickets/usuarios`,
                                    type: 'column',
                                    data: finalSerieArray,
                                },
                            ]
                        }
                        console.log('response', response);
                        resolve({statisticsData, tableData, tableHeaders: ['Fecha', 'Cantidad de tickets', 'Cantidad de prestadores', 'Porcentaje'], valueType: 'percentage'});
                    },
                    error: (errorResponse: any) => {
                        console.log('errorResponse', errorResponse);
                        let statisticsData = {
                            labels: 'mes',
                            series: [
                                {
                                    name: `Porcentaje de tickets/usuarios`,
                                    type: 'column',
                                    data: '',
                                },
                            ]
                        }
                        reject({statisticsData, tableData: [], tableHeaders: ['Fecha', 'Cantidad de tickets', 'Cantidad de prestadores', 'Porcentaje'], valueType: 'percentage'});
                    },
                });
        });
    }

    getCallStatisticsBasedInUser(agentId: number) {
        let url: string = `${this.unexaURL}/estadisticas/calls/operator/${agentId}/iso`;

        return new Promise<any>((resolve, reject) => {
            this._httpClient
                .get(url, this._authService.headers_http)
                .subscribe({
                    next: (response: BasicResponseInterface<StatisticsResponse>) => {
                        resolve(response);
                    },
                    error: (errorResponse: any) => {
                        console.log('errorResponse', errorResponse);
                        reject(errorResponse);
                    },
                });
        });
    }
}
